import React, { Component } from 'react';
import LandingPage from '../Components/LandingPage';

export default class HomePage extends Component {

  render() {
    return (
      <div>
        <LandingPage historyData={this.props.history} />
      </div>
    )
  }
}
